import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override serialize(tree: UrlTree): string {
    return this._withTrailingSlash(super.serialize(tree));
  }

  private _withTrailingSlash(url: string): string {
    const splitOn = url.includes('?') ? '?' : '#';
    const pathArray = url.split(splitOn);

    if (!pathArray[0].endsWith('/')) {
      const fileName: string = url.slice(Math.max(0, url.lastIndexOf('/') + 1));
      if (!fileName.includes('.')) {
        pathArray[0] += '/';
      }
    }
    return pathArray.join(splitOn);
  }
}
